
(function(){
  /* Owner-Nachtrag 3: html.anim synchron setzen (Zine-Motion-v2-Muster) -- ohne JS bleibt
     html ohne .anim, Reveal-Vorzustand greift dann nicht, Inhalt bleibt sichtbar. */
  document.documentElement.classList.add('anim');
  var root=document.getElementById('hh'); if(!root) return;

  /* --- Tabs: beide Tablisten, streng auf #hh gescoped --- */
  function wire(list){
    var tabs=[].slice.call(list.querySelectorAll('.hh2-tab'));
    if(!tabs.length) return;
    function sel(t){
      tabs.forEach(function(o){
        var on=(o===t);
        o.setAttribute('aria-selected',on?'true':'false');
        var p=document.getElementById(o.getAttribute('aria-controls'));
        if(p){
          if(on){
            p.removeAttribute('hidden');
            p.classList.remove('swap');
            /* Reflow erzwingen, sonst startet die 240ms-Animation beim
               zweiten Klick auf denselben Tab nicht neu. */
            void p.offsetWidth;
            p.classList.add('swap');
          } else {
            p.classList.remove('swap');
            p.setAttribute('hidden','');
          }
        }
      });
    }
    tabs.forEach(function(t,i){
      t.addEventListener('click',function(){sel(t);});
      t.addEventListener('keydown',function(e){
        var d=e.key==='ArrowRight'?1:e.key==='ArrowLeft'?-1:0;
        if(!d) return;
        e.preventDefault();
        var n=tabs[(i+d+tabs.length)%tabs.length];
        n.focus(); sel(n);
      });
    });
  }
  [].slice.call(root.querySelectorAll('.hh2-tabs')).forEach(wire);

  /* --- Preisrechner --- */
  var TIERS=[{max:20,p:129},{max:25,p:109},{max:50,p:99},{max:100,p:89},{max:250,p:79}];
  var rng=root.querySelector('#hh-range'),num=root.querySelector('#hh-gnum'),
      per=root.querySelector('#hh-per'),tot=root.querySelector('#hh-tot'),
      vat=root.querySelector('#hh-vat'),rows=[].slice.call(root.querySelectorAll('.hh2-trow'));
  /* EN-Lokalisierung des Rechners (main 11.08.2026): die Ausgabezeilen waren fest deutsch
     und erschienen so auch auf /en/-Seiten. DE-Ausgabe bleibt unveraendert. */
  var EN=/^en/i.test(document.documentElement.lang||'');
  function fmt(n){return n.toLocaleString(EN?'en-GB':'de-DE');}
  function price(n){for(var i=0;i<TIERS.length;i++){if(n<=TIERS[i].max) return TIERS[i].p;}return null;}
  function draw(n){
    if(!num) return;
    num.textContent=n>=251?'251+':n;
    var p=price(n);
    if(p===null){
      per.textContent=EN?'on request':'individuell'; tot.textContent=EN?'on request':'auf Anfrage';
      vat.textContent=EN
        ?'From 251 people we put together a separate quote, because setup and crew are planned differently.'
        :'Ab 251 Personen rechnen wir euch ein eigenes Angebot, weil Aufbau und Crew anders geplant werden.';
    } else {
      var VATR=parseFloat(root.getAttribute('data-vat-rate'));
        var net=p*n, hasVat=!isNaN(VATR)&&VATR>0, mwst=hasVat?Math.round(net*VATR):0, gross=net+mwst;
        per.textContent=EN?('€'+fmt(p)):(fmt(p)+' €');
        tot.textContent=EN?('€'+fmt(hasVat?gross:net)):(fmt(hasVat?gross:net)+' €');
        vat.textContent=hasVat
          ?(EN?('Net €'+fmt(net)+' · plus '+Math.round(VATR*100)+'% VAT €'+fmt(mwst)):('Netto '+fmt(net)+' € · zzgl. '+Math.round(VATR*100)+' % MwSt '+fmt(mwst)+' €'))
          :(EN?('Net €'+fmt(net)+' · plus statutory VAT'):('Netto '+fmt(net)+' € · zzgl. gesetzlicher Umsatzsteuer'));
    }
    rows.forEach(function(r){
      r.setAttribute('aria-pressed', (+r.dataset.n===(n>=251?251:TIERS[TIERS.findIndex(function(t){return n<=t.max;})].max))?'true':'false');
    });
  }
  /* Untergrenze aus dem Markup, nicht fest verdrahtet: Graffiti startet bei 10,
     Action Painting bei 15 — beide Seiten teilen sich diese Datei. */
  var MINN=(rng&&parseInt(rng.getAttribute("min"),10))||15;
  /* Stufen aus den sichtbaren Preis-Buttons DIESER Seite lesen, statt sie doppelt zu
     pflegen. Grund (main 11.08.2026): der fest verdrahtete Wert sagte fuer 16-20
     Personen 129 EUR, waehrend Preistabelle, Hero-Zeile und die Anfrage-Mail
     (b2c-preis.js) 109 EUR nannten. Wer aus dem Markup liest, kann nicht driften.
     Faellt das Parsen aus, bleibt die Liste oben als Bestand stehen. */
  (function(){
    if(!rows.length) return;
    var t=[];
    rows.forEach(function(r){
      var mx=parseInt(r.getAttribute('data-n'),10);
      var b=r.querySelector('b');
      var p=b?parseInt(String(b.textContent).replace(/[^0-9]/g,''),10):NaN;
      if(mx>0&&p>0){ t.push({max:mx,p:p}); }
    });
    t.sort(function(a,c){return a.max-c.max;});
    if(t.length){ TIERS=t; }
  })();
  function setN(n){ n=Math.max(MINN,Math.min(251,n)); if(rng) rng.value=Math.min(250,n); draw(n); }
  if(rng){
    rng.addEventListener('input',function(){ setN(+rng.value===250?250:+rng.value); });
    var d=root.querySelector('#hh-dec'), u=root.querySelector('#hh-inc');
    if(d) d.addEventListener('click',function(){setN(+rng.value-1);});
    if(u) u.addEventListener('click',function(){setN(+rng.value+1);});
    rows.forEach(function(r){ r.addEventListener('click',function(){ setN(+r.dataset.n); }); });
    setN(25);
  }

  /* --- EIN Reveal-Rhythmus, max. 3 Stufen --- */
  var els=[].slice.call(root.querySelectorAll('.hh2-rev'));
  function revealAll(){ els.forEach(function(e){ e.classList.add('in'); }); }
  if(!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches){
    revealAll();
  } else {
    var io=new IntersectionObserver(function(es){
      es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } });
    },{rootMargin:'0px 0px -12% 0px'});
    els.forEach(function(e){io.observe(e);});
    /* Netz 1 — Observer erkennbar kaputt: nach 1,5 s hat NICHTS ausgeloest,
       obwohl beim Laden immer Elemente im Sichtfeld stehen. Dann alles zeigen. */
    setTimeout(function(){
      var seen=els.some(function(e){ return e.classList.contains('in'); });
      if(!seen) revealAll();
    },1500);
    /* Netz 2 — bedingungsloser Ausstieg. Was nach 5 s noch versteckt ist, wird
       gezeigt. Kostet die Einblendung fuer Elemente, die dann noch unter der
       Falte stehen; das ist der Preis dafuer, dass Inhalt NIE dauerhaft
       unsichtbar bleiben kann. Sichtbarkeit schlaegt Effekt. */
    setTimeout(revealAll,5000);
  }
})();

/* FAQPage JSON-LD, MECHANISCH aus dem sichtbaren .cfaq-DOM erzeugt (Judge-Auflage
   W4 Punkt 4: "aus dem Sichtbaren generieren, nicht handschreiben"). Läuft nach
   dem Laden, liest exakt die Fragen/Antworten, die im initialen HTML stehen. */
(function(){
  /* Guard 2026-08-07: statisches Snippet b2c-muc-faq-schema liefert bereits
     ein FAQPage im @graph — doppeltes FAQPage disqualifiziert Rich Results.
     Nur injizieren, wenn noch keines im Dokument steht. */
  var have=[].slice.call(document.querySelectorAll('script[type="application/ld+json"]')).some(function(s){return s.textContent.indexOf('"FAQPage"')!==-1});
  if (have) return;
  var items = [].slice.call(document.querySelectorAll('#hh .cfaq > details'));
  if (!items.length) return;
  var mainEntity = items.map(function(d){
    var q = d.querySelector('summary');
    var a = d.querySelector('.a');
    if (!q || !a) return null;
    return {
      "@type": "Question",
      "name": q.textContent.trim(),
      "acceptedAnswer": { "@type": "Answer", "text": a.textContent.trim() }
    };
  }).filter(Boolean);
  if (!mainEntity.length) return;
  var ld = { "@context": "https://schema.org", "@type": "FAQPage", "mainEntity": mainEntity };
  var s = document.createElement('script');
  s.type = 'application/ld+json';
  s.id = 'muc-faq-jsonld';
  s.textContent = JSON.stringify(ld);
  document.head.appendChild(s);
})();

/* b2cVideoLoader 10.08.2026 (main): data-src-Videos laden+starten, sobald sichtbar.
   Fehlte komplett — Hero-Loops aller Staedte spielten deshalb nie. */
(function(){
  function arm(vid){
    var done=false;
    function activate(){
      if(done) return; done=true;
      vid.querySelectorAll('source[data-src]').forEach(function(s){ s.src=s.dataset.src; });
      vid.load();
      var p=vid.play(); if(p&&p.catch) p.catch(function(){});
    }
    if('IntersectionObserver' in window){
      new IntersectionObserver(function(es,io){
        es.forEach(function(e){ if(e.isIntersecting){ activate(); io.disconnect(); } });
      },{rootMargin:'200px'}).observe(vid);
    } else { activate(); }
  }
  function boot(){ document.querySelectorAll('video').forEach(function(v){ if(v.querySelector('source[data-src]')) arm(v); }); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot); else boot();
})();
